export default function formatMoney(money) {
  const [intNum, floatNum] = money.toFixed(2).split(".");
  const rankNumbers = intNum.replace(/.+?(?=\D|$)/, (f) => {
    return f.replace(/(\d)(?=(?:\d\d\d)+$)/g, "$1 ");
  });

  return `${rankNumbers},${floatNum}`;
}
